import React, { FunctionComponent, MouseEvent, PropsWithChildren, ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import './Tab.scss'

export interface TabProps {
  to?: string
  text?: string
  active?: boolean
  propClassName?: string
  onClick?(e: MouseEvent<HTMLDivElement>): void
}

type Props = PropsWithChildren<TabProps>

export const Tab: FunctionComponent<Props> = ({
  to,
  text,
  active,
  propClassName = '',
  onClick,
  children,
}: Props): ReactElement => {
  let className = `Tab ${propClassName}`
  const navigate = useNavigate()
  if (onClick) {
    className += ' is-clickable'
  }
  if (active) {
    className += ' is-active'
  }
  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    if (to) {
      navigate(to)
    }
    if (onClick) {
      onClick(e)
    }
  }

  return (
    <div className={className} onClick={handleClick}>
      <h3 className="Tab-inner">
        {children ?? text}
      </h3>
    </div>
  )
}

export default Tab
